import {V1OnshapeConfigurationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxios from "../../../../util/EnlilAxios";


class OnshapeConfigurationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/onshape_configurations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.OnshapeConfiguration-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1OnshapeConfigurationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.OnshapeConfiguration-001";
        payload.ShifamedMessage.OnshapeConfiguration = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/onshape_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1OnshapeConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let onshapeConfiguration = {};

        onshapeConfiguration["USID"] = this.getAttributeValue("USID");
        onshapeConfiguration["PartDocumentTypeUSID"] = this.getAttributeValue("PartDocumentTypeUSID");
        onshapeConfiguration["PartFormDocumentRevisionUSID"] = this.getAttributeValue("PartFormDocumentRevisionUSID");
        onshapeConfiguration["AssemblyDocumentTypeUSID"] = this.getAttributeValue("AssemblyDocumentTypeUSID");
        onshapeConfiguration["AssemblyFormDocumentRevisionUSID"] = this.getAttributeValue("AssemblyFormDocumentRevisionUSID");
        onshapeConfiguration["ARDocumentTypeUSID"] = this.getAttributeValue("ARDocumentTypeUSID");
        onshapeConfiguration["ARFormDocumentRevisionUSID"] = this.getAttributeValue("ARFormDocumentRevisionUSID");
        onshapeConfiguration["WebhookURL"] = this.getAttributeValue("WebhookURL");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.OnshapeConfiguration-001";
        payload.ShifamedMessage.OnshapeConfiguration = onshapeConfiguration;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/onshape_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1OnshapeConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default OnshapeConfigurationEnterpriseComponent;